module.exports = __webpack_public_path__ + "static/media/windows-10.373ce827.md";